<template>
  <div>
    <p style="text-decoration: underline; margin-bottom: 0">Prévisualisation</p>
    <b-table
      striped
      hover
      :items="results"
      :fields="fields.entete"
      per-page="5"
    ></b-table>
  </div>
</template>

<script>
export default {
  props: ["results", "fields"],
  data() {
    return {};
  },
};
</script>

<style >
.previsualisation_results .table th,
.previsualisation_results .table td {
  padding: 0 5px !important;
  line-height: 20px !important;
  font-weight: normal !important;
}
</style>